(function () {
var $2e34a704e0e39c71$exports = {};
let $2e34a704e0e39c71$var$filterInstances;
const $2e34a704e0e39c71$var$TERM_SEPARATOR = "|||";
const $2e34a704e0e39c71$var$append = (setA, setB)=>{
    for (const elem of setB)setA.add(elem);
    return setA;
};
const $2e34a704e0e39c71$var$getTermStatus = (venueTermSet, term)=>venueTermSet.has(term);
const $2e34a704e0e39c71$var$parseSerializedTermArray = (venueTermsStr)=>!venueTermsStr?.length ? [] : venueTermsStr.substring($2e34a704e0e39c71$var$TERM_SEPARATOR.length, venueTermsStr.length - $2e34a704e0e39c71$var$TERM_SEPARATOR.length).split($2e34a704e0e39c71$var$TERM_SEPARATOR);
const $2e34a704e0e39c71$var$doFilter = (query)=>{
    const visibilityByFilter = Object.keys(query).reduce((orderedFilterResults, key)=>{
        const term = query[key];
        orderedFilterResults.push($2e34a704e0e39c71$var$filterInstances[key].filter(term));
        return orderedFilterResults;
    }, []);
    return visibilityByFilter[0].map((_, index)=>{
        return visibilityByFilter.reduce((isVisible, filterResults)=>isVisible && filterResults[index], true);
    });
};
class $2e34a704e0e39c71$var$VenueFilter {
    constructor(filterData, options = {}){
        this._hasMultipleTerms = options.hasMultipleTerms;
        const normalizedData = this.constructor.normalizeData(filterData, this._hasMultipleTerms);
        this._processData(normalizedData);
        this._processTerms();
    }
    _processData(normalizedData) {
        this._data = normalizedData.map((terms)=>new Set(terms));
    }
    _processTerms() {
        const collator = new Intl.Collator("en-US");
        const termSet = this._data.reduce((allTerms, venueTermSet)=>$2e34a704e0e39c71$var$append(allTerms, venueTermSet), new Set());
        this._terms = Array.from(termSet.values()).sort(collator.compare);
    }
    get terms() {
        return this._terms;
    }
    filter(term) {
        if (!term) return this._data.map(()=>true);
        return this._data.map((venueData)=>$2e34a704e0e39c71$var$getTermStatus(venueData, term));
    }
    static normalizeData = (filterData, multiple)=>filterData.map((venueTermsStr)=>multiple ? $2e34a704e0e39c71$var$parseSerializedTermArray(venueTermsStr) : [
                venueTermsStr
            ].filter((a)=>a));
}
onmessage = (event)=>{
    const filterEvent = event.data;
    switch(filterEvent.type){
        case "INIT":
            $2e34a704e0e39c71$var$filterInstances = Object.keys(filterEvent.payload).reduce((instances, key)=>{
                const hasMultipleTerms = key === "venueEventStyles";
                instances[key] = new $2e34a704e0e39c71$var$VenueFilter(filterEvent.payload[key], {
                    hasMultipleTerms: hasMultipleTerms
                });
                return instances;
            }, {});
            postMessage({
                type: "READY",
                payload: Object.keys($2e34a704e0e39c71$var$filterInstances).reduce((instances, key)=>{
                    instances[key] = $2e34a704e0e39c71$var$filterInstances[key].terms;
                    return instances;
                }, {})
            });
            break;
        case "FILTER":
            postMessage({
                type: "FILTER_RESULTS",
                payload: $2e34a704e0e39c71$var$doFilter(filterEvent.payload)
            });
            break;
        default:
            // eslint-disable-next-line no-console
            console.warn(`Received unrecognized message ${filterEvent.type}`);
    }
};

})();
//# sourceMappingURL=venue-filter-worker.18ed20a1.js.map
